import React from "react";
import { TwConfirmDialog } from "./tailwind";

export default function DeleteDialog({
  open,
  title,
  message,
  type,
  handleClose,
  handleDelete,
}) {
  return (
    <TwConfirmDialog
      dialogOpen={open}
      dialogType="warning"
      dialogTitle={title}
      dialogMessage={message || `Are you sure you want to delete this${type !== "" ? " " + type : ""}?`}
      onClose={handleClose}
      onConfirm={handleDelete}
    />
  )
}
